import React from 'react';
import {SidebarBanner} from 'app/components/banner/SidebarBanner';
import {useDispatch, useSelector} from 'react-redux';
import {updateNotificationPermission} from 'app/actions/currentUserActions';
import {selectCurrentUser} from 'app/hooks/reduxCreateSelectorHooks';
import {captureSentryException} from 'app/services/sentry/sentryLogging';
import {useNative} from 'app/contexts/NativeContext';

const NewDeviceBanner = () => {
  const dispatch = useDispatch();
  const {notificationPermission} = useSelector(selectCurrentUser);
  const nativeInfo = useNative();

  const handleActivate = async () => {
    try {
      const {getMessagingDeviceToken} = await import('app/services/firebaseMessaging');
      getMessagingDeviceToken(nativeInfo, dispatch, false);
    } catch (error) {
      captureSentryException(error, {extra: {errorLocation: 'importing getMessagingDeviceToken in NewDeviceBanner'}});
    }
  };

  const handleDontAskAgain = () => {
    dispatch(updateNotificationPermission('deactivated'));
  };

  const primaryAction = {label: 'aktivieren', action: handleActivate};
  const secondaryAction = {label: 'nicht mehr fragen', action: handleDontAskAgain};
  const text = 'Deine Zustimmung wird benötigt, um Push-Benachrichtigungen für dieses Gerät zu aktivieren.';
  return (
    <SidebarBanner
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      text={text}
      show={notificationPermission !== 'deactivated'}
    />
  );
};

export {NewDeviceBanner};
